let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cbFgx")).then(() => parcelRequire('31yN3'));